/*eslint-disable*/
import React from 'react'
import { Button, Form as FormUi, Grid, Header, Table, Icon, Modal } from 'semantic-ui-react';
import { Field as Fieldmik, FieldArray } from 'formik';
import { Checkbox } from 'formik-semantic-ui';

import { MyNormalInput } from '../formikInput/input';



const TDSModal = (props) => {


    //ArrayHelper
    Array.prototype.sum = function (prop) {
        var total = 0
        for (var i = 0, _len = this.length; i < _len; i++) {
            total += this[i][prop]
        }
        return total
    }

    return (
        <Modal
            open={props.open}
            onClose={props.onClose}
        >
            <Header>Product TDS</Header>
            <Modal.Content>
                <FieldArray
                    name="tdsOnBills">
                        {({ push, remove, form }) => {

                            const { inititalValues, values } = form
                            const { tdsOnBills } = values

                            const finalTotal = tdsOnBills.reduce((total, obj) => parseFloat(obj.chargeTDS) + parseFloat(total), 0)


                            return (
                                <>
                                    <Table unstackable size="large" compact="very" className="w3-small">
                                        <Table.Header>
                                            <Table.Row >
                                                <Table.HeaderCell className="labelName p-bold-600">Bill No</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">PO No</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">Product Name</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">Taxable Amount</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">TDS%</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">TDS Amount</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">Charge TDS</Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        
                                        <Table.Body>
                                            {tdsOnBills && tdsOnBills.map((object, index) => {

                                                object.chargeTDS = object.tdsAmount

                                                return (
                                                    <Table.Row verticalAlign="middle">
                                                        
                                                        <React.Fragment>
                                                            <Table.Cell>
                                                                {tdsOnBills[index].billNo}                                                                       
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                {tdsOnBills[index].poNo}                                                                       
                                                            </Table.Cell>
                                                            <Table.Cell >
                                                                {tdsOnBills[index].productName}
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                {tdsOnBills[index].taxableAmount}
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                {tdsOnBills[index].tdsPercentage}
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                {tdsOnBills[index].tdsAmount}
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                <Fieldmik 
                                                                    name={`tdsOnBills${[index]}.chargeTDS`} 
                                                                    value={tdsOnBills[index].chargeTDS} 
                                                                    component={MyNormalInput} />
                                                            </Table.Cell>
                                                        </React.Fragment>  
                                                    </Table.Row>
                                                )
                                            }
                                        )}
                                        </Table.Body>
                                    </Table>
                                    <Grid columns={3}>
                                        <Grid.Row className="p-2">
                                            <Grid.Column width={8} />
                                            <Grid.Column>
                                                <FormUi.Group>
                                                    <FormUi.Field>    
                                                        <Header as="label" floated="right" className="labelName" size="tiny">₹ {finalTotal} </Header>                                                                                                             
                                                    </FormUi.Field>
                                                    <FormUi.Field> 
                                                        <Header  as="label" floated="right" className="labelName p-bold-600" size="tiny">Total</Header>  
                                                    </FormUi.Field>
                                                </FormUi.Group>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </>
                            )}
                        }
                </FieldArray>    
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={props.onClose} size="mini">Cancel</Button>
            </Modal.Actions>
        </Modal>
    )

}

export default TDSModal